<template>
  <div class="page">
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="dataSource"
      size="small"
    ></a-table>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue'

  const props = defineProps({
    data: {
      type: Array,
      default: () => [],
    },
  })
  const dataSource = computed(() => props.data)
  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      customRender({ index }) {
        return index + 1
      },
      width: '5%',
    },
    {
      title: 'Region Code',
      dataIndex: 'regionCode',
      width: '15%',
    },
    {
      title: 'Total Pick Req.Nb.',
      dataIndex: 'totalPickRquestNum',
      width: '40%',
    },
    {
      title: 'Completed Pick Req.Nb.',
      dataIndex: 'completedPickRquestNum',
      width: '40%',
    },
  ]
</script>
